export { default } from "./LessonOverviewKeyLearningPoints";
export type { LessonOverviewKeyLearningPointProps } from "./LessonOverviewKeyLearningPoints";
